<div class="container_dialog">
    <div class="header_popup">
        <div class="title_popup">
            <span>{{"Catalogs.quantity_preferences" | translate}}</span>
        </div>
        <button class="close_btn" (click)="closed()">
            <img src="assets/icones/close.svg" alt="">
        </button>
    </div>
    <form class="display_form" [formGroup]="form">
        <div class="first_block">
            <div>
                <img *ngIf="data.image" class="listing_image" [src]="baseUrl + data.image + '?thumbnail=1'" alt="">
                <img *ngIf="!data.image" class="listing_image no-image" src="assets/icones/default-image-product.svg" alt="">
            </div>
            <div class="td_block">
                <span *ngIf="data.name || !data.values" class="bold_span">{{ data.name }}</span><br>
                <span *ngIf="data.values|| !data.name" class="bold_span">{{ data.values.join(' / ') }}</span><br>
                <span class="light_span">{{"inventory.sku"| translate }}: {{data.sku}}</span>
            </div>
        </div>
        <div>
            {{"Catalogs.custome_ovired_describtion" | translate: {min_qte: data.min_qte ?? 'NA', max_qte: data.max_qte ?? 'NA', increment: data.increment ?? 'NA', min_qte_ex: data.min_qte ?? 'NA', min_qte_ex2: (data.min_qte != null && data.increment != null) ? (data.min_qte + data.increment) : 'NA'} }}
        </div>

        <div class="fields">
            <div class="input_field">
                <label>{{"Catalogs.min"| translate}}</label>
                <input class="input" type="number" formControlName="min_qte" [placeholder]="'Catalogs.min'|translate" (input)="sanitize($event)" />
                <span class="indicate_input custom_indic">{{"Catalogs.min" | translate}}</span>
                <span class="error_ms" *ngIf="form.get('min_qte')?.touched  && form.get('min_qte')?.hasError('required')">
                  {{"common.required_field" | translate}}
                </span>
                <span class="error_ms"  *ngIf="form.hasError('minQte')">{{ form.getError('minQte') }}</span>
            </div>
            <div class="input_field">
                <label>{{"Catalogs.max"| translate}}</label>
                <input class="input" type="number" formControlName="max_qte"[placeholder]="'Catalogs.max'|translate" (input)="sanitize($event)" />
                <span class="indicate_input custom_indic">{{"Catalogs.max" | translate}}</span>
                <span class="error_ms" *ngIf="form.get('max_qte')?.touched  && form.get('max_qte')?.hasError('required')">
                  {{"common.required_field" | translate}}
                </span>
                <span class="error_ms" *ngIf="form.hasError('minMax')">{{ form.getError('minMax') }}</span>
            </div>
            <div class="input_field">
                <label>{{"Catalogs.increment"| translate}}</label>
                <input class="input" type="number" formControlName="increment" [placeholder]="'Catalogs.increment'|translate"  (input)="sanitize($event)" />
                <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                <span class="error_ms" *ngIf="form.get('increment')?.touched && form.get('increment')?.hasError('required')">
                  {{"common.required_field" | translate}}
                </span>
                <span class="error_ms"  *ngIf="form.hasError('increment')">{{ form.getError('increment') }}</span>
                <span class="error_ms"  *ngIf="form.hasError('incrementMin')">{{ form.getError('incrementMin') }}</span>
            </div>
        </div>
        <div class="fields">
            <div class="input_field" style="width: auto;">
                <label for="">{{ "Catalogs.can_be_sold_out_of_stock" | translate }}</label>
                <mat-slide-toggle formControlName="can_be_sold_out_of_stock">
                </mat-slide-toggle>
            </div>
        </div>
    </form>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">{{"common.cancel"| translate}}</button>
        <button class="save_btn_pop_up blue_btn" (click)="save()">
            <span>{{"common.save" | translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
    </div>
</div>
